const salesAr = {
    category: require('../../lang/ar/sales/Category').default,
    customer: require('../../lang/ar/sales/Customer').default,
    customerCategory: require('../../lang/ar/sales/CustomerCategory').default,
    customerGroup: require('../../lang/ar/sales/CustomerGroup').default,
    customerRouteAssignment: require('../../lang/ar/sales/CustomerRouteAssignment').default,
    salesOrder: require('../../lang/ar/sales/CustomerSalesOrder').default,
    customerType: require('../../lang/ar/sales/CustomerType').default,
    deliveryPlanning: require('../../lang/ar/sales/DeliveryPlanning').default,
    dispatchAdvice: require('../../lang/ar/sales/DispatchAdvice').default,
    dispatchPlanning: require('../../lang/ar/sales/DispatchPlanning').default,
    grade: require('../../lang/ar/sales/Grade').default,
    merchandiseRack: require('../../lang/ar/sales/MerchandiseRack').default,
    paymentTerms: require('../../lang/ar/sales/PaymentTerms').default,
    region: require('../../lang/ar/sales/Region').default,
    routes: require('../../lang/ar/sales/Routes').default,
    salesTarget: require('../../lang/ar/sales/SalesTarget').default,
    stockTransfer: require('../../lang/ar/sales/StockTransfer').default,
    tourPlan: require('../../lang/ar/sales/TourPlan').default,
    vehicle: require('../../lang/ar/sales/Vehicle').default,
    salespersonLiveLocation: require('../../lang/ar/sales/SalespersonLiveLocation').default,
};

export default salesAr;